const topics = [
  { label: '暑期档热剧', heat: '9.8W', icon: 'ri-sun-line' },
  { label: '国产科幻', heat: '8.2W', icon: 'ri-rocket-2-line' },
  { label: '古装权谋', heat: '7.5W', icon: 'ri-ancient-gate-line' },
  { label: '悬疑刑侦', heat: '6.9W', icon: 'ri-search-eye-line' },
  { label: '日漫新番', heat: '6.3W', icon: 'ri-ghost-line' },
  { label: '国民综艺', heat: '5.8W', icon: 'ri-emotion-happy-line' },
  { label: '年代大剧', heat: '5.4W', icon: 'ri-history-line' },
  { label: '都市情感', heat: '4.9W', icon: 'ri-heart-pulse-line' },
  { label: '院线大片', heat: '4.6W', icon: 'ri-film-line' },
  { label: '短剧微综', heat: '4.2W', icon: 'ri-smartphone-line' },
  { label: '纪录片', heat: '3.8W', icon: 'ri-global-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">热门话题</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">全站热议话题，发现你感兴趣的影视内容</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 hover:bg-background-200 border border-background-200/70 rounded-lg text-sm transition-colors cursor-pointer group"
            >
              <span className="w-6 h-6 rounded-md bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${topic.icon} text-primary-600 text-xs`}></i>
              </span>
              <span className="text-foreground-700 font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}